import React, { useEffect, useRef, useState } from "react";
import { Image } from "react-bootstrap";
import { GroupLogo } from "../../components/index.js";
import PropTypes from "prop-types";
import PoweredByRAK from "../../images/poweredByRAK.png";
import { LoginPageStyled } from "./styled.js";
import {
  LOGINPAGE_TILELIST,
  LOGIN_CAROUSEL_INTERVAL,
  LOGIN_CAROUSEL_HEIGHT,
  LOGIN_CAROUSEL_WIDTH,
  LOGIN_CAROUSEL_ITEM_HEIGHT,
  LOGIN_CAROUSEL_VISIBLE_COUNT,
} from "../../config/constants.js";
import { ActiveSlideLogo } from "../../assets/icons/index.js";
import { colors } from "../../config/colors.js";

const CENTER_INDEX = Math.floor(LOGIN_CAROUSEL_VISIBLE_COUNT / 2);

const LoginWrapper = ({ children }) => {
  const totalItems = LOGINPAGE_TILELIST.length;
  const extendedItems = [
    ...LOGINPAGE_TILELIST,
    ...LOGINPAGE_TILELIST.slice(0, LOGIN_CAROUSEL_VISIBLE_COUNT),
  ];
  const [scrollIndex, setScrollIndex] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setScrollIndex((prev) => (prev + 1 >= totalItems ? 0 : prev + 1));
    }, LOGIN_CAROUSEL_INTERVAL);
    return () => clearInterval(intervalRef.current);
  }, [totalItems]);

  const getItemStyle = (index) => {
    const position = index - scrollIndex;
    const distance = Math.abs(position - CENTER_INDEX);
    const translateY = (position - CENTER_INDEX) * LOGIN_CAROUSEL_ITEM_HEIGHT;
    const scale = distance === 2 ? 1 : 0.8;

    return {
      transform: `translateY(${translateY}px) scale(${scale})`,
      zIndex: 100 - distance,
      backgroundColor: distance === 2 ? colors.white : colors.primary,
      borderColor: distance === 2 ? "transparent" : colors.logoDisabled,
    };
  };

  return (
    <LoginPageStyled>
      <div className="login-body-container">
        <div className="login-logo-wrapper">
          <GroupLogo />
          {children}
          <Image
            src={PoweredByRAK}
            width={188}
            height={13}
            className="powered-by-rak"
          />
        </div>
      </div>
      <div className="login-section-container">
        <div className="carousel-container">
          <div className="carousel-viewport">
            {extendedItems.map((item, index) => {
              const activeIndex = scrollIndex + 4;
              return (
                <div
                  key={`${item}-${index}`}
                  className="carousel-item"
                  style={getItemStyle(index)}
                >
                  {activeIndex === index && (
                    <div className="carosuel-item-active-logo">
                      <ActiveSlideLogo />
                    </div>
                  )}
                  <Image
                    src={activeIndex === index ? item.activeImage : item.image}
                    alt={item.content}
                    loading="lazy"
                    width={LOGIN_CAROUSEL_WIDTH}
                    height={LOGIN_CAROUSEL_HEIGHT}
                  />
                  {activeIndex === index && (
                    <div className="carosuel-item-active-text">
                      {item.content}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </LoginPageStyled>
  );
};

LoginWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoginWrapper;
